<template>
	<!-- HTML LOGIN -->
	<div v-if="login">
		<div v-if="languages" class="row">
			<div v-if="languages.length" class="col-md-12">
				<div class="panel panel-default">
					<div class="panel-body">
						<select v-model="$i18n.locale" class="form-control">
							<option v-for="language in languages" :value="language.lang_code">
								{{ language.name }}
							</option>
						</select>
					</div><!-- /panel-body -->
				</div><!-- /panel panel-default -->
			</div><!-- /col-md-3 -->
		</div><!-- /row -->
	</div>

	<!-- HTML NAVBAR -->
	<li v-else class="nav-item dropdown">
		<template v-if="languages">
			<template v-if="languages.length">
				<li style="margin-left: 20px; margin-bottom: 10px;">
					<template v-for="language in languages">
						<a
							@click="changeLocale(language)"
							class="dropdown-item"
							href="javascript:void(0)"
							style="padding-left: 10px;">
							<template v-if="language.img">
								<img :src="$env.ROOT + language.img" :alt="language.name" :title="language.name">
							</template>
							<template v-else>
								{{ language.name }}
							</template>
						</a>
					</template>
				</li>
			</template>
		</template>
	</li>
</template>

<script>
	export default {
		props: ['login'],
		data () {
			return {
				languages: null,
				lang_code: this.$route.params.lang,
				language: null,
			}
		},
		created() {
			this.init()
		},
		watch: {
			'$route.params.lang': function (lang_code) {
				this.lang_code = lang_code
				this.setLanguage()
			},
		},
		methods: {
			init() {
				this.getLanguages()
			},
			getLanguages() {
				this.$http.get("languages")
				.then(response => {
					this.languages = response.body
					this.setLanguage()
				}).catch(function(response) {
					console.log(response)
				})
			},
			changeLocale(language) {
				this.$i18n.locale = language.lang_code
			},
			setLanguage() {
				if(this.lang_code) {
					if(this.languages) {
						if(this.languages.length) {
							var that = this
							var language = this.languages.find(function(language) {
								return language.lang_code == that.lang_code
							})
							if(language) {
								this.language = language
							}
						}
					}
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/chooseLanguage/layout/ChooseLanguage.vue